
import { getExam, getExamList,getExamByPost} from "../../api/service.js"
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";

let that;
export default{
    components:{
      HeadCom,
      FooterCom
    },
    data(){
        return{
          dataSure: false,
          examListHeight:{height:window.innerHeight-220+'px'},
          imgHeight:{height:window.innerHeight-260+'px'},
          exerciseRecordList:[],
          imgList:[],
          dialogTableVisible:false
        }
    },
    created(){
      that=this;
      that.getExerciseRecordList();
    },
    methods: {
      getExerciseRecordList(){
        let url="/exercise/exerciseRecordList";
        var data={ pageNum:1,pageSize:100};
        getExamList(url,data).then(res=>{
          if(res.success){
            that.exerciseRecordList=res.data;
            if(!that.exerciseRecordList.length){
              that.dataSure = true;
            }else{
              that.dataSure = false;
            }
          }else{
            this.$message.error(res.message)
          }
        })
      },
      //做题记录 查看结果
      viewResults(exerciseId){
        this.$router.push({
          path:"/practiceResult",
          query:{
            exerciseId:exerciseId
          }

        });
      },
      //做题记录 再做一次
      getAgainExam(exerciseId,courseId){
        let url="/exercise/exerciseDetailVerification";
        let data={exerciseId:exerciseId,courseId:courseId};
        getExam(url,data).then(res=> {
          if (res.success) {
            this.$router.push({
              path:"/examDetail",
              query:{
                exerciseId:exerciseId,
                courseId:courseId
              }
            });
          }else{
            this.$alert(res.message, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        })

      },
      openImg(obj){
        that.dialogTableVisible=true;
        that.imgList=obj.split(",")
      }
      }
}
